<template>
  <div>
    <div id="banner" v-html="banner"></div>
    <div id="header-wrapper">
      <div id="header">
        <a href="https://talkonlinepanel.com" target="_blank" class="logo">
          <img :src="`${IMAGE_ROOT}/talk.svg`" />
        </a>
        <div class="icon-container">
          <div class="first-row row">
            <img height="12px" :src="`${IMAGE_ROOT}/esomar.svg`" />
          </div>
          <div class="second-row row">
            <div>
              <img height="50px" :src="`${IMAGE_ROOT}/ecommerce.png`" />
            </div>
            <div>
              <img height="50px" :src="`${IMAGE_ROOT}/gdpr.png`" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IMAGE_ROOT } from '~/utils/constants';
export default {
  data() {
    return {
      IMAGE_ROOT,
      banner: `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 375 101.55"><defs><style>.cls-1{fill:#f09263;}.cls-2{fill:#e63446;}.cls-3,.cls-4{fill:#fff;isolation:isolate;}.cls-3{opacity:0.05;}.cls-4{opacity:0.06;}</style></defs><title>header</title><g id="Group_57" data-name="Group 57"><path id="Path_3-2" data-name="Path 3-2" class="cls-1" d="M12.79-4.17,384,29.24l-6.51,72.31L301.15,87.9l-65.81-2-85.06-15L92,69.08,28.54,58.65,7.92,49.93Z"/><path id="Path_2-2" data-name="Path 2-2" class="cls-2" d="M0,0H375V77l-77.71-7.17L231.15,74l-86.6-7.76L86,69.83l-64.58-5L0,57.6Z"/><circle id="Ellipse_2" data-name="Ellipse 2" class="cls-3" cx="330.5" cy="-14.5" r="91.5"/><circle id="Ellipse_3" data-name="Ellipse 3" class="cls-3" cx="375.5" cy="-91.5" r="211.5"/><ellipse id="Ellipse_6" data-name="Ellipse 6" class="cls-3" cx="353" cy="-14.5" rx="77" ry="77.5"/><path id="Polygon_2" data-name="Polygon 2" class="cls-4" d="M17,44,138,254H-104Z"/><path id="Polygon_3" data-name="Polygon 3" class="cls-4" d="M72.86,106.62l-181-.56,90-155.88Z"/><path id="Polygon_4" data-name="Polygon 4" class="cls-4" d="M23.09,78.2l-62.22-2.33L-6.28,23.3Z"/></g></svg>`
    };
  }
};
</script>
